import API_BASE from '../config';
import { SESSION_KEY, readStored } from './storageKeys';

export default async function refreshDeviceToken(authToken, device) {
  try {
    const sessionId = readStored(SESSION_KEY);
    const headers = { 'ngrok-skip-browser-warning': 'true' };
    if (sessionId) {
      headers.Authorization = `Bearer ${sessionId}`;
    } else if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const res = await fetch(`${API_BASE}/token`, {
      headers,
      credentials: 'include',
    });
    if (!res.ok) {
      throw new Error(`Token request failed (${res.status})`);
    }
    const data = await res.json();
    const token = data.token;
    if (device && typeof device.updateToken === 'function' && token) {
      try {
        device.updateToken(token);
        console.log('[TruvaSentinel] device.updateToken successful');
      } catch (e) {
        console.warn('[TruvaSentinel] device.updateToken failed', e);
      }
    }
    return token;
  } catch (e) {
    console.warn('[TruvaSentinel] refreshDeviceToken failed', e);
    throw e;
  }
}
